import { createContext } from 'react';

/**
 * Размер кнопок по месту: в шапке страницы все кнопки действий одной высоты — 34 px, как «Добавить» в Todo
 * (правило дизайн-системы). Явный `size` у кнопки сильнее.
 */
export const ButtonSizeContext = createContext<'normal' | 'small'>('normal');
